import { render, staticRenderFns } from "./OrdersFBMCreation.vue?vue&type=template&id=45e13377&scoped=true"
import script from "./OrdersFBMCreation.vue?vue&type=script&lang=js"
export * from "./OrdersFBMCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e13377",
  null
  
)

export default component.exports